import React from 'react';
import { connect } from 'react-redux';
import Loader from './../../components/Atoms/Loader';

const mapState = state => ({
  loading: state.posts.loading
});

export default connect(mapState)(({ loading }) => loading ? (<Loader className="posts-loader" />) : null);
